<div class="cssload-container">
  <img src="../../../../assets/AnimacionProcesoFirma.gif" class="cssload-speeding-loading">
  <div class="loading-text">
    <h3 class="titulo-loading">{{mensaje}}</h3>
  </div>
</div>